import { useState, useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import ArcGISMap from "./components/map";
import { useQuoteAddGeometry } from "../../common/hooks/api/quote";
import { toastError, toastSuccess } from "../../helpers/toast-helper";
import { TGeometry } from "../../common/types/common";

const PocMapPage = () => {
    const [graphics, setGraphics] = useState<Record<string, TGeometry>>({});
    const { mutate: addGeometry } = useQuoteAddGeometry();

    const onGeometryCreate = (id, geometry) => {
        setGraphics(graphics => ({
            ...graphics,
            [id]: geometry,
        }));

        addGeometry(geometry, {
            onSuccess: (message) => {
                toastSuccess(message);
            },
            onError: (err) => {
                console.log(err);
                toastError("Cannot translate geometry");
            }
        });
    };

    const onGeometryDelete = (id) => {
        setGraphics(graphics => {
            const newGraphics = {...graphics};
            delete newGraphics[id];
            return newGraphics;
        });
    };

    const list = useMemo(() => Object.entries(graphics).map(([key, value], index) => (
        <div className="mb-2" key={key}>AREA {index + 1} - {value?.rings[0]?.length - 1} points</div>
    )), [graphics]);

    return (
        <Container fluid className="mt-3">
            <Row>
                <Col sm="12" xxl="9" className="d-flex flex-column">
                    <div style={{height: "400px"}}>
                        <ArcGISMap
                            onGeometryCreate={onGeometryCreate}
                            onGeometryDelete={onGeometryDelete}
                        />
                    </div>
                </Col>
                <Col sm="12" xxl="3" className="d-flex flex-column">
                    <div className="card">
                        <div className="card-header">MAP AREAS</div>
                        <div className="card-body">
                            {list.length ? list : "No selected areas"}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default PocMapPage;
